/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./cs-modal-backdrop.component.scss.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./cs-modal-backdrop.component";
var styles_CsModalBackdropComponent = [i0.styles];
var RenderType_CsModalBackdropComponent = i1.ɵcrt({ encapsulation: 2, styles: styles_CsModalBackdropComponent, data: {} });
export { RenderType_CsModalBackdropComponent as RenderType_CsModalBackdropComponent };
export function View_CsModalBackdropComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_CsModalBackdropComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "cs-modal-backdrop", [["class", "modal-backdrop"]], null, null, null, View_CsModalBackdropComponent_0, RenderType_CsModalBackdropComponent)), i1.ɵdid(1, 114688, null, 0, i2.CsModalBackdropComponent, [i1.ElementRef, i1.Renderer2], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CsModalBackdropComponentNgFactory = i1.ɵccf("cs-modal-backdrop", i2.CsModalBackdropComponent, View_CsModalBackdropComponent_Host_0, {}, {}, []);
export { CsModalBackdropComponentNgFactory as CsModalBackdropComponentNgFactory };
